import { Link } from 'react-router-dom'

export default function InviteError() {
  return (
    <>
      <main className="grid min-h-full place-items-center bg-surface-content px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-brand-500">404</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-brand-neutral-900 sm:text-4xl">Invitation not found</h1>
          <p className="mt-5 text-base leading-7 text-text-tertiary">Check your invitation link or contact your organization admin.</p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Link
              to={'/'}
              className="rounded-md bg-brand-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-brand-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
            >
              Continue home
            </Link>
          </div>
        </div>
      </main>
    </>
  )
}
